import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Input from 'components/Input';
import Button from 'components/Button';

import './AgentFeedback.scss';
import Modal from 'components/ModalProvider/Modal/Modal';
import SVG from 'components/SVG';
import crossSVG from '../../img/cross.svg';
import useAgentFeedback from 'features/AgentFeedback/model/useAgentFeedback';
import Spinner from 'components/Spinner/desktop';

const b = block('agent-feedback');

const AgentFeedback = ({ closeFunction }) => {
  const locale = useSelector(state => {
    return state.locale.locale;
  });

  const model = useAgentFeedback(closeFunction);

  return (
    <Modal
      closeFunction={closeFunction}
      content={
        <form className={b()} onSubmit={model.handleFormSubmit}>
          <Spinner isLoading={model.actionProcessing} />

          <SVG className={b('cross')} svgProps={{ svg: crossSVG }} onClick={closeFunction} />
          <div className={b('text')}>{locale.contactLinkText}</div>
          <div className={b('input')}>
            <div className={b('input-label')}>{locale.link}</div>
            <Input
              value={model.state.link}
              onChange={e => model.onChangeLink(e.target.value)}
              placeholder={locale.link}
            />
          </div>
          <div className={b('button')}>
            <Button type="submit" text={locale.save} />
          </div>
        </form>
      }
    />
  );
};

export default AgentFeedback;
